const api_data = {
    AppName: IMPEX_NAME,
    AppKey: IMPEX_KEY
}

export default api_data;